class NewPost {
    _id;
    _title;
    _fullName;
    _role;
    _body;
    _subtitle;
    _dateCreated;
    _dateModified;
    _thumbnail;
    _viewCount;
    _translations;
    _readingTime = {
        _minutes: null,
        _seconds: null,
        _totalTime: null,

        setMinutes(newMinutes) {
            this._minutes = newMinutes;
        },
        setSeconds(newSeconds) {
            this._seconds = newSeconds;
        },
        setTotalTime(newTotalTime) {
            this._totalTime = newTotalTime;
        },

        get minutes() {
            return this._minutes;
        },
        get seconds() {
            return this._seconds;
        },
        get totalTime() {
            return this._totalTime;
        }
    }
    _edited = false;
    _liked = false;
    _hearted = false;
    _clapped = false;
    _surprised = false;
    _confused = false;
    _reactions = [];
    _reports = new Report();
    _comments = new Comments();
    _tag;

    constructor(id, title, body, subtitle, dateCreated, dateModified, thumbnail, viewCount, userId, translations) {
        this._id = id;
        this._title = title;
        this._body = body;
        this._subtitle = subtitle;
        this._dateCreated = dateCreated;
        this._dateModified = dateModified;
        this._thumbnail = thumbnail;
        this._viewCount = viewCount;
        this._userId = userId;
        this._profilePhoto = null;
        this._translations = translations;
    }

    //Setters
    setId(newId) {
        this._id = newId;
    }

    setTitle(newTitle) {
        this._title = newTitle;
    }

    setFullName(newName) {
        this._fullName = newName;
    }

    setRole(newRole) {
        this._role = newRole;
    }

    setBody(newBody) {
        this._body = newBody;
    }

    setSubtitle(newSubtitle) {
        this._subtitle = newSubtitle;
    }

    setDateCreated(newDate) {
        this._dateCreated = newDate;
    }

    setDateModified(newDate) {
        this._dateModified = newDate;
    }

    setThumbnail(newThumbnail) {
        this._thumbnail = newThumbnail;
    }

    setViewCount(newViewCount) {
        this._viewCount = newViewCount;
    }

    setReadingTime(words) {

        words = words.replace(/<[^>]*>/g, " ");
        words = words.replace(/\s+/g, ' ');
        words = words.trim();
        let totalWords = words.split(" ").length;

        let minutes = Math.floor(((totalWords - 1) / 238) * 100) / 100;
        let seconds = (minutes - Math.floor(minutes)).toFixed(2);
        seconds = seconds * 60 / 100;
        minutes = Math.floor(minutes);

        let totalTime = minutes + seconds;
        seconds = Math.ceil(seconds * 100);
        //console.log('Minutes = ' + minutes + ' Seconds = ' + seconds);

        this._readingTime._minutes = minutes;
        this._readingTime._seconds = seconds;
        this._readingTime._totalTime = totalTime;
    }

    setIsEdited(isEdited) {
        this._edited = isEdited;
    }

    setLiked(isLiked) {
        this._liked = isLiked;
    }

    setHearted(isHearted) {
        this._hearted = isHearted;
    }

    setClapped(isClapped) {
        this._clapped = isClapped;
    }

    setSurprised(isSurprised) {
        this._surprised = isSurprised;
    }

    setConfused(isConfused) {
        this._confused = isConfused;
    }

    addNewReaction(newReaction) {
        this._reactions.push(newReaction)
    }

    removeReaction(reaction, number) {
        const index = this._reactions.indexOf(reaction);
        if (index > -1) {
            this._reactions.splice(index, number);
        }
    }

    setReported(isReported, newReport) {
        this._reports._reported = isReported;
        this._reports._totalReports++;
        this._reports._reportArray.push(newReport);
    }

    setComments(newComment) {
        this._comments._commentArray.push(newComment);
        this._comments._totalComments++;
    }

    setTag(newTag) {
        this._tag = newTag;
    }

    setProfilePhoto(photo) {
        this._profilePhoto = photo;
    }
    setTranslations(newTranslations) {
        this._translations = newTranslations;
    }



    //Getters
    get id() {
        return this._id;
    }

    get title() {
        return this._title;
    }

    get fullName() {
        return this._fullName;
    }

    get role() {
        return this._role;
    }

    get body() {
        return this._body;
    }

    get subtitle() {
        return this._subtitle;
    }

    get dateCreated() {
        return this._dateCreated;
    }

    get dateModified() {
        return this._dateModified;
    }

    get thumbnail() {
        return this._thumbnail;
    }

    get viewCount() {
        return this._viewCount;
    }

    get readingTime() {
        return this._readingTime;
    }

    get edited() {
        return this._edited;
    }

    get liked() {
        return this._liked;
    }

    get hearted() {
        return this._hearted;
    }

    get clapped() {
        return this._clapped;
    }

    get surprised() {
        return this._surprised;
    }

    get confused() {
        return this._confused;
    }

    get reactions() {
        return this._reactions;
    }

    get reports() {
        return this._reports;
    }

    get comments() {
        return this._comments;
    }

    get tag() {
        return this._tag;
    }

    get userId() {
        return this._userId;
    }

    get profilePhoto() {
        return this._profilePhoto;
    }
    get translations() {
        return this._translations;
    }
}

class Comments {
    _totalComments = 0;
    _commentArray = [];

    setCommentArray(newCommentArray) {
        this._commentArray = newCommentArray;
    }

    addNewComment(newComment) {
        this._commentArray.push(newComment);
    }

    setTotalComments(newCommentTotal) {
        this._totalComments = newCommentTotal;
    }

    addNewCommentTotal() {
        this._totalComments++;
    }

    deleteComment(comment) {
        let arrayIndex;
        for (let i = 0; i < this._commentArray.length; i++) {
            if (this._commentArray[i].comment === comment) {
                arrayIndex = i;
                if (arrayIndex > -1) {
                    this._commentArray.splice(arrayIndex, 1);
                }
            }
        }
        this._totalComments--;
    }

    get totalComments() {
        return this._totalComments;
    }

    get commentArray() {
        return this._commentArray;
    }
}

class Comment {
    _id;
    _comment;
    _liked = false;
    _hearted = false;
    _clapped = false;
    _confused = false;
    _surprised = false;
    _reactions = [];
    _firstname = "";
    _lastname = "";
    _reports = new Report();

    constructor(id, comment, firstname, lastname, userId) {
        this._id = id;
        this._userId = userId;
        this._comment = comment;
        this._firstname = firstname;
        this._lastname = lastname;
    }

    setId(id) {
        this._id = id;
    }

    setComment(comment) {
        this._comment = comment;
    }

    addNewReaction(newReaction) {
        this._reactions.push(newReaction)
    }

    setReport(report) {
        this._report = report;
    }

    setLiked(isLiked) {
        this._liked = isLiked;
    }

    setHearted(isHearted) {
        this._hearted = isHearted;
    }

    setClapped(isClapped) {
        this._clapped = isClapped;
    }

    setSurprised(isSurprised) {
        this._surprised = isSurprised;
    }

    setConfused(isConfused) {
        this._confused = isConfused;
    }

    

    //Getters
    get id() {
        return this._id;
    }

    get comment() {
        return this._comment;
    }

    get reactions() {
        return this._reactions;
    }

    get reports() {
        return this._reports;
    }

    get liked() {
        return this._liked;
    }

    get hearted() {
        return this._hearted;
    }

    get clapped() {
        return this._clapped;
    }

    get surprised() {
        return this._surprised;
    }

    get confused() {
        return this._confused;
    }
    
    get userId() {
    return this._userId;
    }
}

class Report {
    _reportArray = [];
    _totalReports = 0;
    _reported = false;

    //Setters
    setReportNumber(newReportNumber) {
        this._totalReports = newReportNumber;
    }

    addNewReportTotal() {
        this._totalReports++;
    }

    setReported(isReported) {
        this._reported = isReported;
    }

    setReportArray(newReportArray) {
        this._reportArray = newReportArray;
    }

    addNewReport(newReportValue) {
        this._reportArray.push(newReportValue);
    }

    //Getters
    get totalReports() {
        return this._totalReports;
    }

    get reported() {
        return this._reported;
    }

    get reportArray() {
        return this._reportArray;
    }
}

export {
    NewPost,
    Comment,
    Report,
};
